<template>
  <div class="fixed top-4 right-4 z-50">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="mb-4 p-4 rounded-lg shadow-lg max-w-md"
        :class="{
          'bg-green-500 text-white': toast.type === 'success',
          'bg-red-500 text-white': toast.type === 'error',
          'bg-yellow-500 text-white': toast.type === 'warning',
          'bg-blue-500 text-white': toast.type === 'info'
        }"
      >
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <span v-if="toast.type === 'success'" class="mr-2">✓</span>
            <span v-if="toast.type === 'error'" class="mr-2">✕</span>
            <span v-if="toast.type === 'warning'" class="mr-2">⚠</span>
            <span v-if="toast.type === 'info'" class="mr-2">ℹ</span>
            <span>{{ toast.message }}</span>
          </div>
          <button
            @click="removeToast(toast.id)"
            class="ml-4 text-white hover:text-gray-200"
          >
            ✕
          </button>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const toasts = ref([]);
let toastId = 0;

const addToast = (message, type = 'info', duration = 5000) => {
  const id = toastId++;
  toasts.value.push({ id, message, type });
  
  if (duration > 0) {
    setTimeout(() => {
      removeToast(id);
    }, duration);
  }
};

const removeToast = (id) => {
  toasts.value = toasts.value.filter(toast => toast.id !== id);
};

// Expose methods to parent components
defineExpose({
  addToast
});
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style> 